import useToggle from "../../../../../hooks/useToggle.js";
import { springConfigs, useReveal } from "../../../../../hooks/useReveal.jsx";
import { ImgForPath } from "../../../../../lib/images.jsx";
import DefaultPortal from "../../../../../design-system/utils/DefaultPortal/DefaultPortal.jsx";
import IconButton from "../../../../../design-system/components/IconButton/IconButton.jsx";
import cx from "../../../../../lib/cx.js";
import { styles } from "./PreviwImg.css.ts";

export const PreviewImg = ({
  path,
  width = 400,
  height = 250,
  className = styles.coverImg,
}) => {
  const [open, { toggle, off }] = useToggle();
  const reveal = useReveal(open, {
    config: springConfigs.quickNoBounce,
  });
  return (
    <>
      <ImgForPath
        path={path}
        contain
        height={height}
        width={width}
        className={cx(className, styles.preview)}
        onClick={toggle}
      />
      {reveal(() => (
        <DefaultPortal>
          <div className={styles.container} onClick={off}>
            <div className={styles.onlyButton}>
              <IconButton
                onClick={off}
                name="xmark"
                theme={"dark"}
                size="45px"
                aria-label="Schließen"
              />
            </div>
            <ImgForPath path={path} className={styles.fullView} />
          </div>
        </DefaultPortal>
      ))}
    </>
  );
};
